export default __webpack_public_path__ + "e7769c0d5338a8f60b24a7794c3f0ea8.png";